import {SectionListData} from 'react-native';
import {SectionListFormat, StudentScheduleFormat} from 'stores/ClassStore';

export enum SectionType {
  singleItem,
  firstItem,
  regularItem,
  lastItem,
}

interface SectionFormat {
  title: string;
  data: object[];
}

interface ItemFormat {
  title: string;
}

export function determineSectionItemType<T extends ItemFormat, N extends SectionFormat> (
  index: number,
  section: SectionListData<T, N>,
  globalData: N[],
) {
  for (const item of globalData) {
    if (item.title == section.title) {
      if (item.data.length == 1) {
        return SectionType.singleItem;
      }

      if (index == item.data.length - 1) {
        return SectionType.lastItem;
      }

      if (index == 0) {
        return SectionType.firstItem;
      }

      return SectionType.regularItem;
    }
  }

  return SectionType.lastItem;
};
